import { FC } from 'react'
import './index.less'
import { Badge, Radio } from 'antd'

export type buttonGroupButton = {
  text: string
  onClick: () => void
  disabled?: boolean
  badge?: {
    count: number
  }
}

type PerButtonGroupProps = {
  buttons: buttonGroupButton[]
  defaultValue?: number
  variant?: 'pastel' | 'bold'
  disabled?: boolean
  size?: 'default' | 'small'
}

export const PerButtonGroup: FC<PerButtonGroupProps> = ({ buttons, defaultValue, variant = 'pastel', disabled, size = 'default' }) => {
  return (
    <Radio.Group
      defaultValue={defaultValue ? defaultValue : 0}
      buttonStyle="solid"
      className={'per-btnGroup ' + variant}
      disabled={disabled}
      size={size}
    >
      {buttons.map((button: buttonGroupButton, i: number) => (
        <Radio.Button value={i} disabled={button.disabled} key={i} onClick={() => button.onClick()}>
          {button.badge ? <Badge count={button.badge.count}>{button.text}</Badge> : button.text}
        </Radio.Button>
      ))}
    </Radio.Group>
  )
}
